import { SERVICES_AN_ERROR_OCCURRED_LOADING } from 'common/constants/services/services';

// Allocation Values
export const ALLOCATION_VALUES_BY_COMPANY_QUERY_KEY = 'ALLOCATION_VALUES_BY_COMPANY';
export const ALLOCATION_VALUES_BY_COMPANY_TITLE = 'Allocation Values';
export const ALLOCATION_VALUES_BY_COMPANY_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  ALLOCATION_VALUES_BY_COMPANY_TITLE
);

// Company Summary
export const COMPANY_SUMMARY_BY_MD_QUERY_KEY = 'COMPANY_SUMMARY_BY_MD';
export const COMPANY_SUMMARY_BY_MD_TITLE = 'Company Summary';
export const COMPANY_SUMMARY_BY_MD_DEFAULT_ERROR_MESSAGE
  = SERVICES_AN_ERROR_OCCURRED_LOADING(COMPANY_SUMMARY_BY_MD_TITLE);

// Company Measurement Date
export const COMPANY_MEASUREMENT_DATE_BY_MD_QUERY_KEY = 'COMPANY_MEASUREMENT_DATE_BY_MD';
export const COMPANY_MEASUREMENT_DATE_BY_MD_TITLE = 'Company Measurement Date';
export const COMPANY_MEASUREMENT_DATE_BY_MD_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  COMPANY_MEASUREMENT_DATE_BY_MD_TITLE
);

// Company Cap IQ Overview
export const COMPANY_CAP_IQ_OVERVIEW_QUERY_KEY = 'COMPANY_CAP_IQ_OVERVIEW';
export const COMPANY_CAP_IQ_OVERVIEW_TITLE = 'Company Cap IQ Overview';
export const COMPANY_CAP_IQ_OVERVIEW_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  COMPANY_CAP_IQ_OVERVIEW_TITLE
);

// Company Mutual Fund Marks
export const COMPANY_MUTUAL_FUND_MARKS_QUERY_KEY = 'COMPANY_MUTUAL_FUND_MARKS';
export const COMPANY_MUTUAL_FUND_MARKS_TITLE = 'Mutual Fund Marks';
export const COMPANY_MUTUAL_FUND_MARKS_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  COMPANY_MUTUAL_FUND_MARKS_TITLE
);

// Company News
export const COMPANY_NEWS_QUERY_KEY = 'COMPANY_NEWS';
export const COMPANY_NEWS_TITLE = 'News & Press Releases';
export const COMPANY_NEWS_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(COMPANY_NEWS_TITLE);

// Company Key Developments
export const COMPANY_KEY_DEVELOPMENTS_QUERY_KEY = 'COMPANY_KEY_DEVELOPMENTS';
export const COMPANY_KEY_DEVELOPMENTS_TITLE = 'Cap IQ Key Developments';
export const COMPANY_KEY_DEVELOPMENTS_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(COMPANY_KEY_DEVELOPMENTS_TITLE);

// Company Financial History
export const COMPANY_FINANCIAL_HISTORY_QUERY_KEY = 'COMPANY_FINANCIAL_HISTORY';
export const COMPANY_FINANCIAL_HISTORY_TITLE = 'Financial History';
export const COMPANY_FINANCIAL_HISTORY_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(COMPANY_FINANCIAL_HISTORY_TITLE);

// Company Funding Rounds
export const COMPANY_FUNDING_ROUNDS_QUERY_KEY = 'COMPANY_FUNDING_ROUNDS';
export const COMPANY_FUNDING_ROUNDS_TITLE = 'Fundraising Rounds';
export const COMPANY_FUNDING_ROUNDS_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(COMPANY_FUNDING_ROUNDS_TITLE);

// Company Cap IQ Funding Rounds
export const COMPANY_CAP_IQ_FUNDING_ROUNDS_QUERY_KEY = 'COMPANY_CAP_IQ_FUNDING_ROUNDS';
export const COMPANY_CAP_IQ_FUNDING_ROUNDS_TITLE = 'Cap IQ Funding Rounds';
export const COMPANY_CAP_IQ_FUNDING_ROUNDS_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(COMPANY_CAP_IQ_FUNDING_ROUNDS_TITLE);

// Company Zanbato Pricing
export const COMPANY_ZANBATO_PRICING_QUERY_KEY = 'COMPANY_ZANBATO_PRICING';
export const COMPANY_ZANBATO_PRICING_TITLE = 'ZX Index Value';
export const COMPANY_ZANBATO_PRICING_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  COMPANY_ZANBATO_PRICING_TITLE
);

export const COMPANY_ZANBATO_ASK_PRICING_QUERY_KEY = 'COMPANY_ZANBATO_ASK_PRICING';
export const COMPANY_ZANBATO_BID_PRICING_QUERY_KEY = 'COMPANY_ZANBATO_BID_PRICING';
export const COMPANY_ZANBATO_REPORTED_MARKS_QUERY_KEY = 'COMPANY_ZANBATO_REPORTED_MARKS';
export const COMPANY_ZANBATO_CLOSED_TRANSACTIONS_QUERY_KEY = 'COMPANY_ZANBATO_CLOSED_TRANSACTIONS';
export const COMPANY_ZANBATO_MARKS_VALUATION_QUERY_KEY = 'COMPANY_ZANBATO_MARKS_VALUATION';

// Cap Table Versions
export const CAP_TABLE_VERSIONS_BY_COMPANY_AND_MD_QUERY_KEY = 'CAP_TABLE_VERSIONS_BY_COMPANY_AND_MD';
export const CAP_TABLE_VERSIONS_BY_COMPANY_AND_MD_TITLE = 'Cap Table Versions';
export const CAP_TABLE_VERSIONS_BY_COMPANY_AND_MD_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  CAP_TABLE_VERSIONS_BY_COMPANY_AND_MD_TITLE
);
